
import router from "@/router";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  PropType,
  watch,
} from "vue";
import { useStore } from "vuex";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { useRoute } from "vue-router";

interface Filter {
  typeOfReview: string;
  title: string;
  appCode: string;
  appStatus: string;
  irbStatus: string;
  reviewer: string;
  piEmail: string;
}

export default defineComponent({
  name: "dropdown-irbchair-apps-filter",
  components: {},
  props: {
    tableCallFunction: String,
    filtersDisabled: Boolean,
    hideRadio: Boolean,
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const tableCallAFunction: string = props.tableCallFunction!;
    const filtersDisabledC = ref(props.filtersDisabled!);

    const titleFilter = computed(() => {
      return store.getters.currentIrbAppTitleFilter;
    });

    const data = ref<Filter>({
      typeOfReview: "all",
      title: titleFilter?.value,
      appCode: "",
      appStatus: "all",
      irbStatus: "all",
      reviewer: "",
      piEmail: "",
    });

    watch(
      () => titleFilter?.value,
      () => {
        //MenuComponent.hideDropdowns(undefined);
        data.value.title = titleFilter?.value;
        applyFilter();
      }
    );

    watch(
      () => route?.path,
      () => {
        //MenuComponent.hideDropdowns(undefined);
        data.value.title = titleFilter?.value;
        applyFilter();
      }
    );

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      const scrollElRef = ref<null | HTMLElement>(null);
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const currentIrbMembers = computed(() => {
      return store.getters.currentIrbMembers;
    });


    const resetFilter = () => {
      store.commit(Mutations.SET_IRB_APP_TITLE, "");
      data.value.typeOfReview = "all";
      data.value.title = "";
      data.value.appCode = "";
      data.value.appStatus = "all";
      data.value.irbStatus = "all";
      data.value.reviewer = "";
      data.value.piEmail = "";
      store.dispatch(tableCallAFunction != null ? tableCallAFunction : "", {
        params: {
          Page: 1,
          RecordsPerPage: 8,
        },
      });
    };

    const applyFilter = () => {
      var irbStatus = "";
      var appStatus = "";
      if (data.value.appStatus == "Approved") {
        irbStatus = "Approved";
        appStatus = "Submitted";
      } else if (data.value.appStatus == "Re-assigned") {
        irbStatus = "";
        appStatus = "Re-assigned";
      } else if (data.value.appStatus == "pending-approval") {
        irbStatus = "Under Review";
        appStatus = "Submitted";
      } else if (data.value.appStatus == "Submitted") {
        appStatus = "Submitted";
        
      } else if (data.value.appStatus == "faculty-review") {
        appStatus = "Sponsor Under Review";
        
      } else if (data.value.appStatus == "faculty-approved-not-submitted") {
        appStatus = "SponsorApproved";
        
      }
      
      store.commit(Mutations.SET_IRB_APP_TITLE, data?.value?.title);
      store.dispatch(tableCallAFunction != null ? tableCallAFunction : "", {
        params: {
          Page: 1,
          RecordsPerPage: 8,
          TypeOfReview:
            data.value.typeOfReview == "all" ? "" : data.value.typeOfReview,
          Title: data.value.title,
          PiEmail: data.value.piEmail,
          AppCode: data.value.appCode,
          AppStatus: appStatus,
          IrbStatus: irbStatus,
          Reviewer: data.value.reviewer,
        },
      });
    };

    return {
      data,
      resetFilter,
      applyFilter,
      currentIrbMembers,
    };
  },
});
